import { TUTORIAIS } from './tutoriais.config'

/**
 * Etapas do "Ciclo Mensal de Resultados e Reuniões", exibidas no diagrama
 * interativo aberto pelo botão de tutoriais da tela inicial (/app).
 * Cada etapa reaproveita um vídeo já cadastrado em tutoriais.config.js —
 * nenhum arquivo .mp4 novo é necessário.
 */
export const FLUXO_TRABALHO = [
  {
    numero: 1,
    bloco: 'operacional',
    titulo: 'Momento de Análise',
    papel: 'Colaborador',
    descricao: 'Coordenador / supervisor insere o resultado e a análise de cada indicador.',
    tutorial: TUTORIAIS['/app/indicadores-stereotype'][0],
  },
  {
    numero: 2,
    bloco: 'operacional',
    titulo: 'Auditoria de Evidências',
    papel: 'Auditor',
    descricao: 'Valida a evidência do resultado com a fonte do dado primário.',
    tutorial: TUTORIAIS['/app/evaluar'][1],
  },
  {
    numero: 3,
    bloco: 'operacional',
    titulo: 'Validação de Resultado',
    papel: 'Assessor P. E.',
    descricao: 'Valida o resultado versus a evidência.',
    tutorial: TUTORIAIS['/app/evaluar'][0],
  },
  {
    numero: 4,
    bloco: 'tatico',
    titulo: 'Momento de Análise',
    papel: 'Gerente',
    descricao: 'Analisa cada indicador tático conforme o consolidado dos setores.',
    tutorial: TUTORIAIS['/app/kpi-analysis'][1],
  },
  {
    numero: 5,
    bloco: 'tatico',
    titulo: 'Avaliação de Resultado',
    papel: 'Diretor de Área',
    descricao: 'Avalia o resultado e a análise apresentada pelo gerente.',
    tutorial: TUTORIAIS['/app/kpi-analysis'][0],
  },
  {
    numero: 6,
    bloco: 'estrategico',
    titulo: 'Momento de Análise',
    papel: 'Diretor de Área',
    descricao: 'Analisa o indicador estratégico conforme o consolidado das gerências.',
    tutorial: TUTORIAIS['/app/kpi-analysis'][0],
  },
  {
    numero: 7,
    bloco: 'estrategico',
    titulo: 'Avaliação de Resultado',
    papel: 'Diretor Geral',
    descricao: 'Reunião geral com todos os gestores.',
    tutorial: TUTORIAIS['/app/kpi-analysis'][0],

  },
  {
    numero: 8,
    bloco: 'pdca',
    titulo: 'PDCA',
    papel: 'Colaborador - setor',
    descricao: 'Criação do Plano de Ação.',
    tutorial: TUTORIAIS['/app/feedback'][0],

  },
    {
    numero: 9,
    bloco: 'pdca',
    titulo: 'PDCA',
    papel: 'Gerente - setor',
    descricao: 'Gestão do Plano de Ação.',
    tutorial: TUTORIAIS['/app/feedback'][1],

  },
]

export const FLUXO_BLOCOS = [
  { key: 'operacional', titulo: 'Resultados Operacionais', cor: 'blue darken-3' },
  { key: 'tatico', titulo: 'Resultados Táticos', cor: 'blue darken-2' },
  { key: 'estrategico', titulo: 'Resultados Estratégicos', cor: 'blue lighten-1' },
  { key: 'pdca', titulo: 'PLANO DE AÇÃO', cor: 'red lighten-1' },
]
